import { BannerInformationAPI } from '@core/typings/api/custom-alerts.typing';
import { BaseYCActionState, RegisterYCState } from '@yourcause/common/state';


@RegisterYCState()
export class CustomAlertsState extends BaseYCActionState {
  readonly allBannerRecords: BannerInformationAPI.BannerInformationDisplay[];
}
